import { render, staticRenderFns } from "./SpineExerciseVideoDetailPage.vue?vue&type=template&id=e47c306e&scoped=true"
import script from "./SpineExerciseVideoDetailPage.vue?vue&type=script&lang=js"
export * from "./SpineExerciseVideoDetailPage.vue?vue&type=script&lang=js"
import style0 from "./SpineExerciseVideoDetailPage.vue?vue&type=style&index=0&id=e47c306e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47c306e",
  null
  
)

export default component.exports